/**
 * Enum Trạng thái xử lý chênh lệch
 * ndquang1 23.07.2024
 */
export default {
  Resolved: 1,
  UnResolve: 0,
};
